(() => {
  if (new URLSearchParams(location.search).has('ph_cart_edit')) return;
  let addingModal = null, submittedModal = null, loadingEndTimer;
  let redirectLocked = false, addPending = false;
  const trackedButtons = new Map();
  const cartMode = () => document.querySelector('script[data-ph-after-add]')?.dataset.phAfterAdd === 'cart';
  function trackButtons() {
    document.querySelectorAll('#customily-cart-btn').forEach(button => {
      if (!trackedButtons.has(button)) trackedButtons.set(button, {disabled:button.disabled, busy:button.getAttribute('aria-busy'), unavailable:button.getAttribute('aria-disabled')});
    });
  }
  function paintPending() {
    if (!addPending && !redirectLocked) return;
    document.querySelectorAll('#customily-cart-btn').forEach(button => {
      button.classList.add('ph-atc-locked');
      button.setAttribute('aria-busy','true');
      button.setAttribute('aria-disabled','true');
    });
  }
  function resetPending() {
    addPending = false;
    trackedButtons.forEach((previous,button) => {
      button.classList.remove('ph-atc-locked');
      if (previous.busy === null) button.removeAttribute('aria-busy'); else button.setAttribute('aria-busy',previous.busy);
      if (previous.unavailable === null) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled',previous.unavailable);
    });
  }
  window.addEventListener('click', event => {
    if (!event.target.closest?.('#customily-cart-btn')) return;
    if (redirectLocked || (addPending && event.isTrusted)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (!addPending) {
      trackedButtons.clear(); trackButtons();
      addPending = true;
      paintPending();
    }
  }, true);
  window.addEventListener('ph-cart-redirecting', () => {
    redirectLocked = true; addPending = true; paintPending();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    redirectLocked = false;
    clearTimeout(loadingEndTimer);
    trackedButtons.forEach((previous,button) => {
      button.disabled = previous.disabled;
      button.classList.remove('running','is--loading');
    });
    resetPending();
    document.querySelectorAll('.ph-preview-adding').forEach(modal => modal.classList.remove('ph-preview-adding'));
    addingModal = null; submittedModal = null;
  });
  function finishAdding(close) {
    if (redirectLocked || (close && cartMode())) {
      redirectLocked = true; addPending = true; paintPending(); return;
    }
    resetPending();
    clearTimeout(loadingEndTimer);
    const modal=addingModal || (close && submittedModal);
    addingModal=null;
    if(!modal)return;
    modal.classList.remove('ph-preview-adding');
    const button=modal.querySelector('#customily-cart-btn');
    button?.removeAttribute('aria-busy');button?.removeAttribute('aria-disabled');
    if(close){
      submittedModal=null;
      // Let Customily finish its synchronous success updates before closing its Vue modal.
      setTimeout(()=>document.querySelector('.customily-modal-preview-only .customily-close-button')?.click(),50);
    }
  }
  // The app's cloned button closes the preview before clicking its source button.
  // Forward to that same source directly, retaining the real validation/request flow.
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('.customily-modal-preview-only #customily-cart-btn');
    if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(addingModal)return;
    const source=[...document.querySelectorAll('#customily-cart-btn')].find(el=>!el.closest('.customily-modal-preview-only'));
    if(!source || source.disabled || source.classList.contains('running'))return;
    addingModal=button.closest('.customily-modal-preview-only');
    submittedModal=addingModal;
    addingModal.classList.add('ph-preview-adding');
    button.setAttribute('aria-busy','true');button.setAttribute('aria-disabled','true');
    source.click();
  },true);
  window.addEventListener('customily-add-to-cart-completed',()=>finishAdding(true));
  const themeJQuery=window.jQuery_T4NT || window.jQuery;
  if(themeJQuery)themeJQuery(document).on('add:cart:success.phPreviewLoading',()=>finishAdding(true));
  window.addEventListener('customily-starts-adding-to-cart',()=>{clearTimeout(loadingEndTimer);addPending=true;paintPending();});
  window.addEventListener('customily-loaders-hidden',()=>{
    if(addPending || addingModal) loadingEndTimer=setTimeout(()=>{
      if (redirectLocked) return;
      const nativeBusy=[...document.querySelectorAll('[data-atc-form]')].some(button=>button.classList.contains('is--loading') || button.classList.contains('running'));
      if (!nativeBusy) finishAdding(false);
    },300);
  });
  window.addEventListener('customily-required-error',()=>finishAdding(false));
  window.addEventListener('customily-add-addons-error',()=>finishAdding(false));
  if (themeJQuery) themeJQuery(document).on('ajaxError.phPreviewLoading', (event, xhr, settings) => {
    const path = new URL(settings?.url || '/', location.href).pathname;
    if (!redirectLocked && (path.endsWith('/cart/add') || path.endsWith('/cart/add.js'))) finishAdding(false);
  });
  // Close only the backdrop; keep Customily's own cleanup and in-flight add state.
  document.addEventListener('click', event => {
    if (event.target.matches?.('.customily-modal-preview-only') && !addingModal) {
      event.target.querySelector('.customily-close-button')?.click();
    }
  });
  document.addEventListener('keydown', event => {
    if(event.key !== 'Escape' || addingModal) return;
    const modal=document.querySelector('.customily-modal-preview-only');
    if(modal && getComputedStyle(modal).display !== 'none') modal.querySelector('.customily-close-button')?.click();
  });
    const enhance = () => {
    document.querySelectorAll('.customily-modal-preview-only').forEach(modal => {
      const main=modal.querySelector('.main'),wrapper=main?.querySelector('.cl-preview-wrapper');
      if(!wrapper)return;
      modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Looks Good to Go?');
      let heading=wrapper.querySelector('.ph-preview-heading');
      if(!heading){
        heading=document.createElement('div');heading.className='ph-preview-heading';
        heading.innerHTML='<h2><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 4C5 4 1 12 1 12s4 8 11 8 11-8 11-8S19 4 12 4Zm0 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/></svg>Looks Good to Go?</h2><p>Please double-check your preview to receive your item faster.</p>';
        wrapper.prepend(heading);
      }
      let review=wrapper.querySelector('.ph-preview-review');
      if(!review){review=document.createElement('div');review.className='ph-preview-review';wrapper.append(review);}
      if(review.dataset.version!=='2'){
        const check='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 12 5 5L20 5"/></svg>';
        review.innerHTML='<p>'+check+'<span>Full refund for faulty production. No questions asked.</span></p><p>'+check+'<span>In demand.</span></p>';
        review.dataset.version='2';
      }
      const atc=wrapper.querySelector('#customily-cart-btn');
      if(atc&&!atc.querySelector('.ph-preview-cart-icon')){
        const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
        icon.setAttribute('class','ph-preview-cart-icon');icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');
        icon.innerHTML='<path d="M2 3h3l2 13h12l2-9H6M12 3v8m-4-4h8"/><circle cx="9" cy="21" r="1"/><circle cx="18" cy="21" r="1"/>';
        atc.prepend(icon);
      }
      if(!wrapper.querySelector('.ph-preview-dismiss')){
        const close=document.createElement('button');close.type='button';close.className='ph-preview-dismiss';close.textContent='Close';
        close.addEventListener('click',()=>{if(!addingModal)main.querySelector('.customily-close-button')?.click();});wrapper.append(close);
      }
      const x=main.querySelector('.customily-close-button');
      if(x&&!x.dataset.phCloseReady){x.setAttribute('role','button');x.setAttribute('aria-label','Close preview');x.tabIndex=0;x.dataset.phCloseReady='true';x.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();x.click();}});}
    });
  };
  let enhancePending=false;
  new MutationObserver(()=>{if(enhancePending)return;enhancePending=true;requestAnimationFrame(()=>{enhancePending=false;enhance();});}).observe(document.body,{childList:true,subtree:true});enhance();
})();
